import { Col, Row } from 'antd';
import { Routes } from 'config/routes';
import { FC, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './ops-theme.module.css';

import {
  OperationsDashboardProvider,
  useOperationsDashboardContext,
} from '../../contexts/OperationsDashboardContext';
import OperationsDashboardTabs from '../OperationsDashboardTabs';

const OperationsDashboardInner: FC = () => {
  const { isDarkMode, setContainerWidth } = useOperationsDashboardContext();
  const location = useLocation();
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      setContainerWidth(Math.round(entry.contentRect.width));
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [setContainerWidth]);

  useEffect(() => {
    if (location.pathname === Routes.DashboardsOperations) {
      navigate(Routes.DashboardsOperationsOverview, { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    document.body.classList.toggle('ops-dark', isDarkMode);
    document.body.classList.toggle('ops-light', !isDarkMode);
    return () => {
      document.body.classList.remove('ops-dark', 'ops-light');
    };
  }, [isDarkMode]);

  return (
    <div
      ref={containerRef}
      className={`${styles.opsTheme} ${!isDarkMode ? styles.lightMode : ''}`}
    >
      <Row gutter={[10, 10]} justify="space-between">
        <Col span={24}>
          <OperationsDashboardTabs />
        </Col>
      </Row>
    </div>
  );
};

const OperationsDashboard: FC = () => (
  <OperationsDashboardProvider>
    <OperationsDashboardInner />
  </OperationsDashboardProvider>
);

export default OperationsDashboard;
